<template>
    <table class="mt-3">
        <thead class="bg-lightGray h-11">
        <tr :style="bordered" class="text-center">
            <th
                v-for="(header, index) in headers"
                v-bind:key="index"
                :class="{
                    'border': header.bordered,
                    'd-none d-sm-table-cell': header.hideOnMobile,
                    'd-sm-none': header.hideOnBig,
                }"
            >
                <slot :name="'checkAll_' + index" :item="index"/>
                {{ getItemName(headers, header, true, true) }}
            </th>
        </tr>
        </thead>

        <tbody>
        <tr
            :style="bordered"
            v-for="(item, rowIndex) in calcData"
            v-bind:key="rowIndex"
            class="h-11 text-center"
        >
            <td
                v-for="(field, index) in bodyProperties"
                v-bind:key="index"
                :class="{
                    'border': field.bordered,
                    'd-none d-sm-table-cell': field.hideOnMobile,
                    'd-sm-none': field.hideOnBig,
                     'table-danger': isSelectable === false ?
                                    typeof field.isBgColorDanger === 'function' && field.isBgColorDanger(item)
                                    ||
                                    (field.name === 'checkboxes' && field.bgDanger(item))
                                    :
                                    typeof field.isBgColorDanger === 'function' && field.isBgColorDanger(item)
                                    ||
                                    (field.name === 'checkboxes' && field.bgDanger(item))
                                    ||
                                    (typeof field.name === 'function' && field.bgDanger(item))
                                    ||
                                    (field.name === 'id' && field.bgDanger(item))
                                    ||
                                    (field.name === 'actions' && field.bgDanger(item)),
                     'table-warning': isSelectable === false ?
                                    typeof field.isBgColorWarning === 'function' && field.isBgColorWarning(item)
                                    ||
                                    (field.name === 'checkboxes' && field.bgWarning(item))
                                    :
                                    typeof field.isBgColorWarning === 'function' && field.isBgColorWarning(item)
                                    ||
                                    (field.name === 'checkboxes' && field.bgWarning(item))
                                    ||
                                    (typeof field.name === 'function' && field.bgWarning(item))
                                    ||
                                    (field.name === 'id' && field.bgWarning(item))
                                    ||
                                    (field.name ==='firstPurchase' && field.bgWarning(item))
                                    ||
                                    (field.name === 'custom' && field.bgWarning(item))
                                    ||
                                    (field.name === 'telephone' && field.bgWarning(item))
                                    ||
                                    (field.name === 'averageCheck' && field.bgWarning(item))
                                    ||
                                    (field.name === 'actions' && field.bgWarning(item)),
                }"
            >

                <slot name="checkboxes" v-if="field === 'checkboxes' || field.name === 'checkboxes'" :item="item"/>
                <slot name="firstPurchase" v-if="field === 'firstPurchase' || field.name === 'firstPurchase'" :item="item"/>
                <slot name="custom" v-if="field === 'custom' || field.name === 'custom'" :item="item"/>
                <slot name="telephone" v-if="field === 'telephone' || field.name === 'telephone'" :item="item"/>
                <slot name="score" v-if="field === 'score' || field.name === 'score'" :item="item"/>
                <slot name="picture" v-if="field === 'picture' || field.name === 'picture'" :item="item"/>
                <slot name="averageCheck" v-if="field === 'averageCheck' || field.name === 'averageCheck'" :item="item"/>
                <slot name="actions" v-if="field === 'actions' || field.name === 'actions'" :item="item"
                      :rowIndex="rowIndex"/>
                {{ getItemName(item, field) }}
            </td>
        </tr>
        <slot name="summary"></slot>
        </tbody>
    </table>
</template>

<script>

export default {
    name: "TableTag",
    props: {
        headers: {
            type: Array,
            required: true,
        },

        // optional
        getterName: {
            type: String,
            default: undefined,
        },
        data: {
            type: Array,
            default: undefined,
        },
        bodyProperties: {
            type: Array,
            required: true,
        },
        fetchGetterName: {
            type: String,
            default: undefined,
        },
        isSelectable: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: String,
            default: '',
        }
    },
    mounted() {
        if (this.getterName === undefined && this.data === undefined) {
            console.error("You must to specify getterName of data property")
            return
        }

        if (this.fetchGetterName !== undefined) {
            this.$root.showOverlay = true

            if (this.$route.params.page) {
                this.$store.dispatch(this.fetchGetterName, this.$route.params.page)
                    .then(() => {
                        this.$root.showOverlay = false
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.$store.dispatch(this.fetchGetterName)
                    .then(() => {
                        this.$root.showOverlay = false
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }

        }
    },
    computed: {
        calcData() {
            if (this.getterName !== undefined) {
                return this.$store.getters[this.getterName]
            }

            if (this.data !== undefined) {
                return this.data
            }

            return []
        },
    },
    methods: {
        getItemName(item, field, isWithLang = false, isHeader = false) {
            if (field === 'actions') {
                if (isHeader) {
                    return this.$t(field)
                }

                return ''
            }

            if (typeof field === 'function') {
                return field(item)
            }

            if (typeof field === 'object') {
                return this.getItemName(item, field.name, isWithLang)
            }

            return isWithLang ? this.$t(field) : item[field];
        },
    },
}
</script>

<style scoped>
table tr {
    border-bottom: 1px solid  #EFE8FC;
}
</style>
